import { Controller, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import "../../_shark_models/Gallery";

class GalleryManager extends Controller {
	constructor () {
		super("galleryManager");
	}


		
	delete (gallery) {
		const rd = NousCore.api.createRequest({ item: gallery.export() });

		NousCore.api.send("gallery/delete", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						galleryManager.emit("deleted");
						break;
					case 404:
						galleryManager.emit("deletionError");
						break;
				}
			}
		});
	}

	getList (parentFolder) {
		let data = { item: { folderGuid: "" } };

		if (parentFolder) {
			data.item.folderGuid = parentFolder.guid;
		}

		const rd = NousCore.api.createRequest(data);

		NousCore.api.send("gallery/get-list", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const galleryList = Shark.getInstanceList("Gallery", data.items);

						galleryList.sort((a, b) => {
							if (a.name > b.name) {
								return 1;
							}
							else if (a.name < b.name) {
								return -1;
							}
						});

						Shark.set("galleryList", galleryList);

						galleryManager.emit("listChanged");
						break;
					case 404:
						galleryManager.emit("listGetError");
						break;
				}
			}
		});
	}

	save (gallery) {
		const rd = NousCore.api.createRequest({ item: gallery.export() });
		const action = gallery.guid === "" ? "insert" : "update";

		NousCore.api.send(`gallery/${action}`, rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						gallery.import(data.items[0]);
						gallery.clean();

						let galleryList = Shark.get("galleryList");

						if (!galleryList) {
							galleryList = [];
							Shark.set("galleryList", galleryList);
						}
						if (action === "insert") {
							galleryList.push(gallery);
						}

						galleryManager.emit("saved");
						galleryManager.emit("listChanged");
						break;
					case 99:
						galleryManager.emit("saveError");
						break;
				}
			}
		});
	}
}

const galleryManager = new GalleryManager();

Shark.registerController(galleryManager);

export { galleryManager };
